// extracted by mini-css-extract-plugin
export default {"fileViewer":"FileViewer_fileViewer__sFoGT","header":"FileViewer_header__YfzoR","description":"FileViewer_description__vzE6L","main":"FileViewer_main__an322"};